import { render, staticRenderFns } from "./StudentTcfPrint.vue?vue&type=template&id=63f2e315&scoped=true&"
import script from "./StudentTcfPrint.vue?vue&type=script&lang=js&"
export * from "./StudentTcfPrint.vue?vue&type=script&lang=js&"
import style0 from "./StudentTcfPrint.vue?vue&type=style&index=0&id=63f2e315&lang=scss&scoped=true&"
import style1 from "./StudentTcfPrint.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f2e315",
  null
  
)

export default component.exports